var MailmagaUI = {
  Update: {
    addSubmitListener() {
      var mailmagaUpdateSubmit = document.getElementById('mailmaga-update-submit');
      if (mailmagaUpdateSubmit) {
        mailmagaUpdateSubmit.addEventListener('click', this.submit);
      }
    },

    submit(e) {
      var btn = e.target;
      if (btn) {
        window.location.href = "/account";
      }
    }
  }
}

window.addEventListener('DOMContentLoaded', function() {
  MailmagaUI.Update.addSubmitListener();
});